// ChallengeTierPage — Step 1: choose tier
// iOS HIG: inset-grouped list, each tier as a row with checkmark trailing

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChallengeLayout, IOSList, IOSPrimaryButton, IOSRow, IOSCheck, stepPath } from './ChallengeLayout';
import { TIER_OPTIONS } from './data';
import { setTier, type TierName } from './store';
import { BrandLogo } from '../../../components/Brand';

export function ChallengeTierPage() {
  const nav = useNavigate();
  const [selected, setSelected] = useState<TierName | null>(null);

  function onContinue() {
    if (!selected) return;
    setTier(selected);
    nav(stepPath('size'));
  }

  return (
    <ChallengeLayout current="tier">
      <div>
        <div className="px-1 pb-2 text-[13px] font-normal uppercase tracking-wide text-[#8E8E93]">Account type</div>
        <IOSList>
          {TIER_OPTIONS.map((t, i) => {
            const isSel = selected === t.tier;
            return (
              <IOSRow
                key={t.tier}
                testId={`tier-card-${t.tier.toLowerCase()}`}
                selected={isSel}
                onClick={() => setSelected(t.tier)}
                showDivider={i < TIER_OPTIONS.length - 1}
                leading={<BrandLogo name={t.tier} size={28} />}
                title={
                  <div className="flex items-center gap-2">
                    <span className="text-[17px]">{t.tier}</span>
                    {t.badge && (
                      <span className="rounded-full bg-[#FF9500] px-2 py-0.5 text-[11px] font-semibold uppercase text-white">{t.badge}</span>
                    )}
                  </div>
                }
                subtitle={t.tagline}
                trailing={<IOSCheck selected={isSel} />}
              />
            );
          })}
        </IOSList>
        <p className="mt-3 px-1 text-[13px] text-[#8E8E93]">
          Each tier has its own account sizes, rules and profit split. You can upgrade later.
        </p>
      </div>

      <div className="mt-8">
        <div className="px-1 pb-2 text-[13px] font-normal uppercase tracking-wide text-[#8E8E93]">Features included</div>
        <div className="rounded-[12px] bg-white px-4 py-2 text-[13px] text-[#3C3C43]">
          <FeatureRow label="EOD Balance drawdown" />
          <FeatureRow label="Up to 80% profit split" last />
        </div>
      </div>

      <div className="mt-8">
        <IOSPrimaryButton onClick={onContinue} disabled={!selected}>
          Continue
        </IOSPrimaryButton>
      </div>
    </ChallengeLayout>
  );
}

function FeatureRow({ label, last }: { label: string; last?: boolean }) {
  return (
    <div className={['flex items-center justify-between py-3', last ? '' : 'border-b border-[#C6C6C8]/55'].join(' ')}>
      <span className="text-[15px] text-[#1C1C1E]">{label}</span>
      <span className="text-[15px] text-[#8E8E93]">All tiers</span>
    </div>
  );
}
